<div class="container container-narrow">
    <h2>Terms &amp; Conditions</h2>
    <p><b>Last updated: Jan 26th 2026</b></p>
    <p>
        Welcome to <b>Urlo</b> (“we”, “us”, “our”). By using our website, services, and embeddable feedback button (the “Service”), you agree to these
        Terms and Conditions (“Terms”). If you do not agree, please do not use the Service.
    </p>
    <h3>1. Use of the Service</h3>
    <p>
        You may use the Service to create, customize, and embed feedback buttons on websites you
        own or control. You agree not to misuse the Service, interfere with its operation, or use
        it for unlawful purposes.
    </p>

    <h3>2. Accounts</h3>
    <p>
        To access certain features, you must create an account. You are responsible for maintaining
        the confidentiality of your account credentials and for all activities under your account.
    </p>

    <h3>3. User Content</h3>
    <p>
        You retain ownership of all content you submit through the Service. By using the Service,
        you grant us a non-exclusive, worldwide, royalty-free license to process and display your
        content solely to operate and improve the Service.
    </p>

    <h3>4. Embeddable Script</h3>
    <p>
        The button script provided by us is licensed, not sold. You may embed it on your website,
        provided you do not modify, resell, or redistribute it without our permission.
    </p>

    <h3>5. Availability</h3>
    <p>
        We strive to keep the Service available, but we do not guarantee uninterrupted or error-free
        operation. We may modify, suspend, or discontinue parts of the Service at any time.
    </p>

    <h3>6. Limitation of Liability</h3>
    <p>
        To the maximum extent permitted by law, we are not liable for indirect, incidental, or
        consequential damages arising from your use of the Service.
    </p>

    <h3>7. Termination</h3>
    <p>
        We may suspend or terminate your access if you violate these Terms. You may stop using the
        Service at any time.
    </p>

    <h3>8. Changes to These Terms</h3>
    <p>
        We may update these Terms from time to time. Continued use of the Service after changes
        means you accept the updated Terms.
    </p>

    <h3>9. Governing Law</h3>
    <p>
        These Terms are governed by the laws of <strong>The Kingdom Of The Netherlands</strong>, without regard
        to conflict of law principles.
    </p>

    <h3>10. Contact</h3>
    <p>
        If you have questions about these Terms, contact us at <strong>support@urlo.site</strong>.
    </p>
</div>

